import Routes from '../../routes/routes'
import { buildPutApi } from '../helpers'
import buildOptions from './buildOptions'

export default buildPutApi({
    route: Routes.reloadRentalCarSearch,
    buildResult: result => result && result.meta && (result.meta.code === 200),
    mapPayload: ({ uuid, id }) => ({
        uuid,
        idUnborn: id,
        logged: true,
    }),
    buildOptions,
})
